module.exports = __webpack_public_path__ + "img/hakuna_img.cf990b08.jpg";